import { ConfigProvider } from 'antd';
import Loading from 'components/shared-components/Loading';
import { darkTheme, lightTheme } from 'configs/ThemeConfig';
import { resources } from 'lang';
import { memo, Suspense } from 'react';
import { useSelector } from 'react-redux';
import Routes from 'routes';

const Layouts = () => {
  const locale = useSelector((state) => state.theme.locale);

  const direction = useSelector((state) => state.theme.direction);

  const currentTheme = useSelector((state) => state.theme.currentTheme);

  const currentAppLocale = resources[locale];

  const themeConfig =
    currentTheme === 'light' ? { ...lightTheme } : { ...darkTheme };

  return (
    <ConfigProvider
      theme={themeConfig}
      direction={direction}
      locale={currentAppLocale.antd}
    >
      <Suspense fallback={<Loading cover="content" />}>
        <Routes />
      </Suspense>
    </ConfigProvider>
  );
};

export default memo(Layouts);
